import React, { createContext, useState } from 'react';

// Create a context
export const TransactionContext = createContext();

// Provider component
export const TransactionProvider = ({ children }) => {
  const [transactionId, setTransactionId] = useState(null);

  return (
    <TransactionContext.Provider value={{ transactionId, setTransactionId }}>
      {children}
    </TransactionContext.Provider>
  );
};
